import { render } from "./CuttingBoardsView.vue?vue&type=template&id=3816de51&scoped=true"
import script from "./CuttingBoardsView.vue?vue&type=script&lang=js"
export * from "./CuttingBoardsView.vue?vue&type=script&lang=js"

import "./CuttingBoardsView.vue?vue&type=style&index=0&id=3816de51&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3816de51"

export default script